var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            "label-col": _vm.labelCol,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-row",
            { staticClass: "flex-row" },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "strainClass",
                      attrs: { label: "主推品系", prop: "strainsNameList" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            gap: "4px",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                mode: "multiple",
                                placeholder: "请选择品系",
                                "collapse-tags": true,
                                disabled: _vm.isDisabled(),
                              },
                              on: { change: _vm.onStrainsChange },
                              model: {
                                value: _vm.form.strainsNameList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "strainsNameList", $$v)
                                },
                                expression: "form.strainsNameList",
                              },
                            },
                            _vm._l(_vm.carStrainsDS, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.strainsCode,
                                  attrs: { value: item.strains },
                                },
                                [_vm._v(_vm._s(item.strains))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                                "line-height": "1.4",
                              },
                            },
                            [_vm._v(" 注意：公路用车与工程用车不可同时选择 ")]
                          ),
                        ],
                        1
                      ),
                      _vm.strFalse
                        ? _c(
                            "a-tooltip",
                            {
                              staticStyle: { "margin-left": "5px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "选择主推品系会删除已选择的主推车型及数量，请谨慎操作"
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                4161886907
                              ),
                            },
                            [_c("a-icon", { attrs: { type: "info-circle" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { staticStyle: { display: "none" }, attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "主推车型及数量",
                        prop: "strainsCarName",
                        "label-col": { span: 5 },
                      },
                    },
                    [
                      _c("a-select", {
                        ref: "selectCarSeriesPopup",
                        staticClass: "proxySelect",
                        attrs: {
                          placeholder: "主推车型及数量",
                          "visible-change": false,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.onShowCarSeries.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.form.strainsCarName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "strainsCarName", $$v)
                          },
                          expression: "form.strainsCarName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "地点",
                        prop: "activityPlace",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-cascader", {
                        attrs: {
                          options: _vm.regionOptions,
                          fieldNames: {
                            label: "areaName",
                            value: "areaName",
                            children: "children",
                          },
                          placeholder: "请选择地点",
                          allowClear: "",
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.activityPlace,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityPlace", $$v)
                          },
                          expression: "form.activityPlace",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "详细地址",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.addressInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addressInfo", $$v)
                          },
                          expression: "form.addressInfo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "是否二网活动",
                        prop: "isSecondaryNetwork",
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { disabled: _vm.isDisabled() },
                          model: {
                            value: _vm.form.isSecondaryNetwork,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isSecondaryNetwork", $$v)
                            },
                            expression: "form.isSecondaryNetwork",
                          },
                        },
                        [
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v(" 是 "),
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v(" 否 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "二网名称",
                        rules: [
                          {
                            required: _vm.form.isSecondaryNetwork === 1,
                            message: "请输入二网名称",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.secondaryNetworkName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "secondaryNetworkName", $$v)
                          },
                          expression: "form.secondaryNetworkName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人姓名", prop: "headName" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headName", $$v)
                          },
                          expression: "form.headName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人电话", prop: "headPhone" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headPhone", $$v)
                          },
                          expression: "form.headPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "备注",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          "auto-size": { minRows: 2, maxRows: 6 },
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "item-line" }, [_vm._v("费用预算")]),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "制作费用" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.makeCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "makeCost", $$v)
                          },
                          expression: "form.makeCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "场地租金" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.siteRent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siteRent", $$v)
                          },
                          expression: "form.siteRent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: "其他", disabled: _vm.isDisabled() },
                      on: { change: _vm.gettotalCost },
                    },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.otherFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "otherFee", $$v)
                          },
                          expression: "form.otherFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合计" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: "" },
                        model: {
                          value: _vm.form.totalCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalCost", $$v)
                          },
                          expression: "form.totalCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.approveBtnDisplay === true
            ? _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "经销商已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.dealerDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dealerDiff", $$v)
                              },
                              expression: "form.dealerDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "区域已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.areaDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "areaDiff", $$v)
                              },
                              expression: "form.areaDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "最高支持费用" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.isDisabled() },
                            model: {
                              value: _vm.form.maxSupportFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "maxSupportFee", $$v)
                              },
                              expression: "form.maxSupportFee",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "item-line" }, [_vm._v("主推车型及数量")]),
      !_vm.isDisabled()
        ? _c(
            "div",
            { staticStyle: { padding: "5px 1%" } },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: { click: _vm.onShowCarSeries },
                },
                [_vm._v("新增")]
              ),
              _c(
                "vxe-button",
                { attrs: { status: "warning" }, on: { click: _vm.deleteOjb } },
                [_vm._v("删除")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "filter-container", staticStyle: { padding: "0px 1%" } },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "max-height":
                  _vm.$store.state.app.height - 300 > 200
                    ? _vm.$store.state.app.height - 200
                    : 200,
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                data: _vm.vehicleModelAndQuantity,
              },
              on: {
                "checkbox-change": _vm.selectionChange,
                "checkbox-all": _vm.selectionChange,
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: { title: "车型名称", field: "vCode", align: "center" },
              }),
              _c("vxe-column", {
                attrs: { title: "数量", field: "quantity", align: "center" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticClass: "car-modal",
          attrs: {
            title: "选择车型",
            visible: _vm.showCarSeries,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCarSeries = $event
            },
            cancel: function ($event) {
              _vm.showCarSeries = false
            },
          },
        },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              [
                _c("a-input", {
                  staticStyle: { width: "200px", "margin-right": "1rem" },
                  attrs: { placeholder: "输入车型", clearable: "" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.carPageData(1)
                    },
                  },
                  model: {
                    value: _vm.planCodeOrName,
                    callback: function ($$v) {
                      _vm.planCodeOrName = $$v
                    },
                    expression: "planCodeOrName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "300px", "margin-right": "1rem" },
                    attrs: {
                      mode: "multiple",
                      placeholder: "选择品系",
                      clearable: "",
                    },
                    model: {
                      value: _vm.showCarStrainsNameSelected,
                      callback: function ($$v) {
                        _vm.showCarStrainsNameSelected = $$v
                      },
                      expression: "showCarStrainsNameSelected",
                    },
                  },
                  _vm._l(_vm.showCarCarStrainsDS, function (item) {
                    return _c(
                      "a-select-option",
                      { key: item.strainsCode, attrs: { value: item.strains } },
                      [_vm._v(_vm._s(item.strains))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "vxe-button",
                  {
                    staticClass: "filter-search-item",
                    attrs: { status: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.carPageData(1)
                      },
                    },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "vxe-button",
                  {
                    staticClass: "filter-search-item",
                    on: {
                      click: function ($event) {
                        return _vm.resetForm()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                loading: _vm.listLoading,
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "max-height":
                  _vm.$store.state.app.height - 350 < 185
                    ? 340
                    : _vm.$store.state.app.height - 350,
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                "checkbox-config": { checkRowKeys: _vm.defaultSelecteRows },
                data: _vm.carList,
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "vCode",
                  title: "车型",
                  align: "center",
                  width: "310",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "quantity",
                  title: "车型数量",
                  align: "center",
                  width: "305",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("a-input-number", {
                          attrs: { min: 1 },
                          model: {
                            value: row.quantity,
                            callback: function ($$v) {
                              _vm.$set(row, "quantity", $$v)
                            },
                            expression: "row.quantity",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.listLoading,
                expression: "!listLoading",
              },
            ],
            staticStyle: { margin: "10px 0 -10px 0" },
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.changePage },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCarSeries = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: { click: _vm.onSeriesConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }